<template>
  <div id="order-files-box" v-if="visible">
    <el-dialog
      title="编辑地址"
      class="order-files-dialog"
      ref="orderFilesDialog"
      :visible.sync="visible"
      :show-close="true"
      :close-on-click-modal="false"
      width="720px"
      destroy-on-close
      v-el-drag-dialog
    >
      <el-form ref="form" :rules="rules" :model="dataForm" label-width="130px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="联系人" prop="Linker">
              <el-input v-model="dataForm.Linker"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="单位名称" prop="CompanyName">
              <el-input v-model="dataForm.CompanyName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="联系人电话" prop="LinkTel">
              <el-input v-model="dataForm.LinkTel"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="详细地址" prop="Address">
              <el-input clearable v-model="dataForm.Address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址选择" style="position: relative;">
              <el-cascader
                v-model="dataForm.AddressArea"
                clearable
                style="width: 100%"
                filterable
                popper-class="absolute"
                :options="cityData"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="默认地址">
              <el-select
                clearable
                style="width: 100%"
                v-model="dataForm.IsDefault"
                placeholder="请选择"
              >
                <el-option label="默认地址" :value="1" />
                <el-option label="非默认地址" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          icon="el-icon-check"
          type="primary"
          @click.stop.prevent="onOK()"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cityData from "@/utils/citySampl.js";

export default {
  name: 'AddressEditForm',
  data() {
    var Phone = (rule, value, callback) => {
      const Tel =
        /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (Tel.test(value)) {
        return callback();
      }
      callback(new Error("请输入正确的电话格式"));
    };
    return {
      cityData,
      visible: false,
      dataForm: {},
      rules: {
        Linker: [{ required: true, message: "不能为空", trigger: "blur" }],
        CompanyName: [{ required: true, message: "不能为空", trigger: "blur" }],
        LinkTel: [
          { required: true, message: "不能为空", trigger: "blur" },
          { validator: Phone, trigger: "blur" },
        ],
        Address: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
    };
  },
  methods: {
    Options(obj) {
      this.dataForm = obj
    },
    Open(onOkCallback) {
      this.visible = true;
      this.onOkCallback = onOkCallback
    },
    Close(){
      this.visible = false
    },
    onOK() {
      const close = this.Close;
      
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        if (typeof this.onOkCallback === 'function') {
          console.log('+ close +', close)
          this.onOkCallback({ ...this.dataForm }, close)
        }
      })

    },
  },
};
</script>

<style lang="scss" scoped>
.order-files-dialog {
  height: 100% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;

  .el-dialog {
    max-height: 95% !important;
    min-height: 300px !important;
    max-width: 95% !important;
    min-width: 540px !important;
    display: flex;
    flex-direction: column;
    position: relative !important;
    margin: 0 auto !important;

    .el-dialog__body {
      padding: 15px;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
      flex: 1;
      height: 99% !important;
      overflow-y: scroll;
      position: relative !important;
    }
  }
}
</style>